console.log('App.routes.ts is being called');
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { SignUpPageComponent } from './sign-up-page/sign-up-page.component';
import { AvailableClansComponent } from './available-clans/available-clans.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    title: 'login',
  },
  {
    path: 'login',
    component: LoginPageComponent,
    title: 'Login Page',
  },
  {
    path: 'sign-up-page',
    component: SignUpPageComponent,
    title: 'Sign Up',
  },
  {
    path: 'available-clans',
    component: AvailableClansComponent,
    title: 'app-available-clans',
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
    title: 'app-verify-email',
  },
  {
    path: '**',
    redirectTo: '', // Redirect wildcard paths to the root
    pathMatch: 'full',
  },
];
